import FeedbackDataStorage from "./feedbackDataStorage";
import { fromFeedbackJson, toFeedbackJson } from "./feedbackJsonConvert";
class FeedbackJsonStorage {
    feedbackDataStorage;
    constructor(feedbackDataStorage) {
        this.feedbackDataStorage = feedbackDataStorage;
    }
    static create(avalancheProvider) {
        return new this(new FeedbackDataStorage(avalancheProvider));
    }
    async getAllFeedback() {
        const data = await this.feedbackDataStorage.get();
        if (data === undefined) {
            return undefined;
        }
        const objects = data
            .map(fromFeedbackJson)
            .filter((o) => o !== undefined)
            .filter((o) => o.address && o.feedback && typeof o.feedback === "object");
        return objects;
    }
    async createFeedbackData(toStore) {
        this.enforceLengthLimits(toStore);
        const id = toStore.address + "-" + Date.now();
        toStore.id = id;
        const data = toFeedbackJson(toStore);
        await this.feedbackDataStorage.set(id, data);
    }
    async updateFeedbackData(toStore) {
        this.enforceLengthLimits(toStore);
        const data = toFeedbackJson(toStore);
        if (toStore.id) {
            await this.feedbackDataStorage.set(toStore.id, data);
        }
        else {
            await this.createFeedbackData(toStore);
        }
    }
    async deleteAllFeedback() {
        await this.feedbackDataStorage.delete();
    }
    enforceLengthLimits(toStore) {
        toStore.feedback.cleanMessage_1 = toStore.feedback.cleanMessage_1.substring(0, 4000);
        /* toStore.feedback.cleanMessage_2 = toStore.feedback.cleanMessage_2.substring(
          0,
          constants.FEEDBACK_TITLE_CHARACTER_LIMIT,
        );
        toStore.feedback.cleanMessage_3 = toStore.feedback.cleanMessage_3.substring(
          0,
          constants.FEEDBACK_TITLE_CHARACTER_LIMIT,
        );*/
    }
}
export default FeedbackJsonStorage;
